import { cn } from "@/lib/utils";
import type { ComponentProps, FC } from "react";

type ParenthesisIconProps = Omit<ComponentProps<"svg">, "viewBox" | "children">;

// Lucide の Parentheses アイコンの左括弧パス
export const ParenthesisLeftIcon: FC<ParenthesisIconProps> = ({
  className,
  ...props
}) => (
  <svg
    viewBox="2 3 10 18"
    preserveAspectRatio="none"
    className={cn("shrink-0 text-monotone-4", className)}
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    {...props}
  >
    <path d="M8 21s-4-3-4-9 4-9 4-9" />
  </svg>
);

// Lucide の Parentheses アイコンの右括弧パス
export const ParenthesisRightIcon: FC<ParenthesisIconProps> = ({
  className,
  ...props
}) => (
  <svg
    viewBox="12 3 10 18"
    preserveAspectRatio="none"
    className={cn("shrink-0 text-monotone-4", className)}
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    {...props}
  >
    <path d="M16 3s4 3 4 9-4 9-4 9" />
  </svg>
);
